<app-modal-basic modalContentId="modal-configuracao-itens-nfe" [showNow]="open" (opened)="onOpened()"
  (closed)="onClosed()">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="modal-title"></i>
      Configuração dos Itens
    </h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="form-group col-sm-12">
          <app-dim-checkbox label="Código de benefício fiscal" formControlName="aplicarCbenef"></app-dim-checkbox>
          <app-combobox-cbenef-fiscais appendTo="#modal-configuracao-itens-nfe" formControlName="cBenef" label=""
            [notFoundPlusIcon]="false" [pencilIcon]="false" [customData]="{ cst: cst }"
            [disabled]="!form.get('aplicarCbenef').value"></app-combobox-cbenef-fiscais>
        </div>
        <div class="form-group col-sm-12" *ngIf="crtNormal">
          <app-dim-checkbox label="Código CST/CSOSN" formControlName="aplicarCst"></app-dim-checkbox>
          <ng-content *ngIf="form.get('aplicarCst').value" select="[slot=tip]"></ng-content>
          <ng-select appendTo="#modal-configuracao-itens-nfe" formControlName="cst" placeholder="Selecione"
            [items]="cstsListCRTNormal" bindLabel="nome" bindValue="id">
          </ng-select>
          <show-errors [control]="form.controls['cst']"></show-errors>
        </div>
        <div class="form-group col-sm-12" *ngIf="crtSimples">
          <app-dim-checkbox label="Código CST/CSOSN" formControlName="aplicarCst"></app-dim-checkbox>
          <ng-content *ngIf="form.get('aplicarCst').value" select="[slot=tip]"></ng-content>
          <ng-select appendTo="#modal-configuracao-itens-nfe" formControlName="cst" placeholder="Selecione"
            [items]="cstsListCRTSimples" bindLabel="nome" bindValue="id">
          </ng-select>
          <show-errors [control]="form.controls['cst']"></show-errors>
        </div>
        <div class="form-group col-sm-12">
          <app-dim-checkbox label="Cód. Benef. Crédito Presumido" formControlName="aplicarCCredPresumido"></app-dim-checkbox>
          <ng-select appendTo="#modal-configuracao-itens-nfe" [loading]="loading['codigosCreditoPresumido']"
            formControlName="cCredPresumido" placeholder="Selecione" [items]="codigosCreditoPresumido"
            bindLabel="descricao" bindValue="codigo">
          </ng-select>
          <show-errors [control]="form.controls['cCredPresumido']"></show-errors>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <button type="submit" class="btn btn-primary">
            <app-loading icone="ti-save" textoLoading="Aplicando" texto="Aplicar"></app-loading>
          </button>
          <button type="button" class="btn btn-danger" (click)="onCancel()">
            <app-loading icone="ti-close" textoLoading="Cancelar" texto="Cancelar"></app-loading>
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer"></div>
</app-modal-basic>